module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/knowledgebase-3cd082b58ea9d2aebdb8f6ebcc4aaea6.png";